import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: 'root'
})

export class SiteContentService {
    constructor(private apiService: ApiService) {

    }

    async getSiteContent(name: string) {
        return await this.apiService.getSiteContent(name);
    }
}